var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedAreaEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.04167,
    y: 1.04167,
    width: 22.9167,
    height: 22.9167,
    rx: 4.51389,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.04167,
    y: 1.04167,
    width: 22.9167,
    height: 22.9167,
    rx: 4.51389,
    stroke: "#FF8027",
    strokeWidth: 2.08333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5556 6.76855C11.411 6.76855 10.2922 7.10796 9.34049 7.74385C8.38882 8.37973 7.64708 9.28355 7.20907 10.341C6.77106 11.3984 6.65646 12.562 6.87975 13.6846C7.10305 14.8072 7.65421 15.8383 8.46354 16.6476C9.27287 17.457 10.304 18.0081 11.4266 18.2314C12.5492 18.4547 13.7128 18.3401 14.7702 17.9021C15.8276 17.4641 16.7315 16.7224 17.3673 15.7707C18.0032 14.819 18.3426 13.7002 18.3426 12.5556C18.3426 11.7956 18.1929 11.0431 17.9021 10.341C17.6113 9.63887 17.185 9.00091 16.6476 8.46354C16.1103 7.92616 15.4723 7.49989 14.7702 7.20907C14.0681 6.91824 13.3156 6.76855 12.5556 6.76855ZM7.48872 12.5556C7.4848 11.5855 7.75982 10.6347 8.28103 9.81642C8.80224 8.99818 9.54766 8.34701 10.4285 7.94046C11.3093 7.53392 12.2885 7.38914 13.2493 7.52337C14.2101 7.6576 15.1121 8.06518 15.8478 8.69757L8.73615 15.8992C7.92603 14.9744 7.48233 13.7851 7.48872 12.5556ZM12.5556 17.616C11.3379 17.617 10.1613 17.176 9.24412 16.375L16.375 9.24412C17.0081 9.97646 17.4175 10.8752 17.5545 11.8334C17.6916 12.7917 17.5506 13.7691 17.1483 14.6496C16.746 15.53 16.0994 16.2764 15.2852 16.8C14.471 17.3236 13.5236 17.6024 12.5556 17.6032V17.616Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAreaEventIcon);
export default __webpack_public_path__ + "static/media/Restricted-Area-Event-Icon.3c62a5b6f84f1b412b195bf2797f8974.svg";
export { ForwardRef as ReactComponent };